let loadMoreBusy = false;

function loadMoreLoadingText() {
    return document.documentElement.lang === "es"
            ? "Cargando carteles…"
            : "Carregant cartells…";
}

function loadMoreBind(button, load) {
    if (!button || typeof load !== "function" || button.dataset.loadMoreBound === "true") {
        return;
    }

    button.dataset.loadMoreBound = "true";
    button.addEventListener("click", async (event) => {
        if (loadMoreBusy) {
            event.preventDefault();
            return;
        }

        event.preventDefault();
        loadMoreBusy = true;
        const originalText = button.textContent;
        button.textContent = loadMoreLoadingText();
        button.setAttribute("aria-busy", "true");
        button.setAttribute("aria-disabled", "true");

        try {
            await load(button);
        } catch (err) {
            console.log("Alguna cosa ha anat malament: " + err);
            console.log(err.stack);
        } finally {
            button.textContent = originalText;
            button.removeAttribute("aria-busy");
            button.removeAttribute("aria-disabled");
            loadMoreBusy = false;
        }
    });
}

export { loadMoreBind };
